function resolveDesktopSidebarPlacement(config = {}) {
  const placementConfig = config.articlePlacements?.desktopSidebar || {};
  const configuredSlotCount = Number(placementConfig.slotCount);
  const slotCount = Number.isFinite(configuredSlotCount) && configuredSlotCount > 0
    ? Math.floor(configuredSlotCount)
    : 4;
  const configuredStickyIndex = Number(placementConfig.stickySlotIndex);
  const stickySlotIndex = Number.isFinite(configuredStickyIndex)
    && configuredStickyIndex >= 1
    && configuredStickyIndex <= slotCount
    ? Math.floor(configuredStickyIndex)
    : null;
  const configuredStickyTop = Number(placementConfig.stickyTopPx);
  const stickyTopPx = Number.isFinite(configuredStickyTop)
    ? Math.max(0, configuredStickyTop)
    : 24;

  return {
    slotCount,
    stickySlotIndex,
    stickyTopPx
  };
}

module.exports = { resolveDesktopSidebarPlacement };
